import {useApolloQuery as useQuery} from 'apollo-hooks'
import gql from 'graphql-tag'

export default function useLoyaltyWallet() {
  const loyaltyToken = 'JustoSpoonity'
  const {loyaltyWallet, refetch} = useQuery({
    query: gql`
      query loyaltyWalletSpoonity($token: String) {
        loyaltyWallet(token: $token)
      }
    `,
    variables: {token: loyaltyToken},
    fetchPolicy: 'network-only'
  })

  return {loyaltyWallet, refetch}
}
